import {
  ROUTER_PATHS,
  transformarAEventosFullCalendar,
  useIsMediaQuery,
} from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Planificador } from "@/shared/interfaces";
import { usePlanificadorStore } from "@/store/erp";
import { EventContentArg } from "@fullcalendar/core/index.js";
import esLocale from "@fullcalendar/core/locales/es";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import Close from "@mui/icons-material/Close";
import { CircularProgress, Grid } from "@mui/material";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

export interface PlanificadorCalendarPageProps {}

const PlanificadorCalendarViewPage: React.FC<
  PlanificadorCalendarPageProps
> = () => {
  const { id } = useParams(); // id del planificador
  const returnUrlPlanificadoresPage = ROUTER_PATHS.operaciones.flotasViewNav;
  const isMobile = useIsMediaQuery("sm");
  const selectedFlota = usePlanificadorStore((s) => s.selectedFlota);

  /////* global state ------------------
  let selectedPlanificador = usePlanificadorStore(
    (s) => s.selectedPlanificador
  ) as Planificador;
  let handleStartPlanificador = usePlanificadorStore(
    (s) => s.handleStartPlanificador
  );
  let handleChangeDatePicker = usePlanificadorStore(
    (s) => s.handleChangeDatePicker
  );
  let valueDatePicker = usePlanificadorStore((s) => s.valueDatePicker);
  let isLoadingCalender = usePlanificadorStore((s) => s.isLoadingCalender);
  let events = usePlanificadorStore((s) => s.events);

  useEffect(() => {
    if (!id) return;
    handleStartPlanificador(id);
  }, []);

  useEffect(() => {
    if (!selectedPlanificador) return;
    const updatedEvents = transformarAEventosFullCalendar(selectedPlanificador.time_map, []);
    usePlanificadorStore.setState({
      events: updatedEvents,
      isLoadingCalender: false,
    });
  }, [handleChangeDatePicker, selectedPlanificador]);  

  return (
    <SingleTableBoxScene
      title={`Planificador Flota: ${
        isLoadingCalender ? "" : selectedFlota?.nombre
      }`}
      enableRedirect={true}
      urlRedirect={returnUrlPlanificadoresPage}
      textRedirect={"Salir"}
      iconRedirect={<Close />}
    >
      <Grid item container xs={12} justifyContent={"center"}>
        {!isLoadingCalender ? (
          <div style={{ width: "100%" }}>
            <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              initialView={isMobile ? "timeGridDay" : "timeGridWeek"}
              locales={[esLocale]} // Configura el locale a español
              datesSet={(date) => {
                handleChangeDatePicker(dayjs(date.start));
                isLoadingCalender = true;
              }}
              events={events}
              initialDate={valueDatePicker?.toDate()} // Establece la fecha por defecto aquí
              scrollTime="07:00:00"
              slotMinTime={{ hour: 7, minute: 0 }}
              slotMaxTime={{ hour: 23, minute: 0 }}
              allDaySlot={false}
              eventContent={(eventInfo) => renderEventContent(eventInfo)}
              headerToolbar={{
                left: "prev,next today",
                center: "title",
                right: "timeGridWeek,timeGridDay",
              }}
              editable={false} // Desactiva el arrastre de eventos
              droppable={false} // Desactiva la posibilidad de soltar eventos
              eventResizableFromStart={false} // Desactiva el redimensionamiento
              selectable={false}
            />
          </div>
        ) : (
          <Grid item style={{ margin: "100px 0px" }}>
            <CircularProgress />
          </Grid>
        )}

        {!selectedPlanificador && !isLoadingCalender && (
          <Grid item style={{ margin: "100px 0px" }}>
            Lo sentimos, no se ha encontrado una planificación para la fecha{" "}
            <b>{valueDatePicker?.format("YYYY-MM-DD")}.</b>
          </Grid>
        )}
      </Grid>
    </SingleTableBoxScene>
  );
};

export default PlanificadorCalendarViewPage;

function renderEventContent(eventInfo: EventContentArg) {
  return (
    <div className="insideStyle">
      <span>
        <b>{eventInfo.timeText}</b>
      </span>
      <span>{eventInfo.event.title}</span>
      <span className="reason">{eventInfo.event.extendedProps.motivo}</span>
      <span className="username">{eventInfo.event.extendedProps.username}</span>
    </div>
  );
}
